<template>
  <select class="apple-ui-select" :value="value" :disabled="disabled" v-bind="$attrs" v-on="forwardedListeners" @input="onInput" @change="onChange"><slot /></select>
</template>
<script>
// Native select retains browser keyboard, form, label and popup behavior.
// `input` returns the selected value for v-model; `change` carries the native event.
export default {
  name: 'AppleSelect', inheritAttrs: false,
  props: { value: { type: [String, Number], default: '' }, disabled: Boolean },
  computed: {
    forwardedListeners() { const listeners = { ...this.$listeners }; delete listeners.input; delete listeners.change; return listeners; },
  },
  methods: {
    onInput(event) { this.$emit('input', event.target.value); },
    onChange(event) { this.$emit('change', event); },
  },
};
</script>
<style scoped>
select.apple-ui-select { box-sizing:border-box; min-width:0; max-width:100%; min-height:var(--apple-ui-control-height,32px); padding:5px 8px; border:1px solid var(--apple-ui-border, var(--apple-border)); border-radius:var(--apple-ui-radius-control,7px); color:var(--apple-ui-text, var(--color-text)); background-color:var(--apple-ui-surface-raised,var(--color-body-bg)); font:inherit; font-size:13px; line-height:1.35; color-scheme:light; cursor:pointer; }
[data-theme='dark'] select.apple-ui-select { color-scheme:dark; }
select.apple-ui-select ::v-deep option { color:var(--apple-ui-text,var(--color-text)); background-color:var(--apple-ui-surface-raised,var(--color-body-bg)); }
select.apple-ui-select:hover:not(:disabled) { border-color:color-mix(in srgb, var(--apple-ui-text, var(--color-text)) 30%, transparent); }
select.apple-ui-select:focus:not(:focus-visible) { outline:none; }
select.apple-ui-select:focus-visible { outline:none; border-color:#7fb4ff; box-shadow:inset 0 0 0 1px #7fb4ff; }
select.apple-ui-select:disabled { opacity:.45; cursor:default; }
</style>
